export var PreinstalledAppNames;
(function (PreinstalledAppNames) {
    PreinstalledAppNames[PreinstalledAppNames["Park"] = 0] = "Park";
    PreinstalledAppNames[PreinstalledAppNames["SpfxTestApp"] = 1] = "SpfxTestApp";
    PreinstalledAppNames[PreinstalledAppNames["Store"] = 2] = "Store";
    PreinstalledAppNames[PreinstalledAppNames["Test"] = 3] = "Test";
    PreinstalledAppNames[PreinstalledAppNames["Todo"] = 4] = "Todo";
    PreinstalledAppNames[PreinstalledAppNames["Yammer"] = 5] = "Yammer";
    PreinstalledAppNames[PreinstalledAppNames["ImmersiveBizchat"] = 6] = "ImmersiveBizchat";
    PreinstalledAppNames[PreinstalledAppNames["OneDrive"] = 7] = "OneDrive";
})(PreinstalledAppNames || (PreinstalledAppNames = {}));
var generateUrlWithCarryOverParams = function (contentUrl, overriddenParams, appendedParams) {
    try {
        var officeUrl_1 = new URL(window.location.href);
        var metaOsContentURL_1 = new URL(contentUrl);
        // CarryOver the param from OfficeUrl to metaOsContentURL, and override it
        overriddenParams.forEach(function (p) {
            var paramValue = officeUrl_1.searchParams.get(p) || '';
            if (paramValue) {
                metaOsContentURL_1.searchParams.set(p, paramValue);
            }
        });
        // Append the param value from OfficeUrl to metaOsContentURL (e.g. append more features to the "features" param)
        appendedParams.forEach(function (p) {
            var paramValue = officeUrl_1.searchParams.get(p) || '';
            if (paramValue) {
                if (metaOsContentURL_1.searchParams.get(p)) {
                    metaOsContentURL_1.searchParams.set(p, metaOsContentURL_1.searchParams.get(p) + ',' + paramValue);
                }
                else {
                    metaOsContentURL_1.searchParams.set(p, paramValue);
                }
            }
        });
        return metaOsContentURL_1.href;
    }
    catch (_a) {
        return contentUrl;
    }
};
export var candidateMOS3AppEntries = [
    {
        appEnumName: PreinstalledAppNames.Test,
        definition: {
            titleId: 'P_07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
            titleDefinition: {
                accentColor: '#000000',
                name: 'Office MetaOS Test App',
                developerName: 'Microsoft Taos Experiences Team',
                iconLarge: {
                    uri: 'https://static2.sharepointonline.com/files/fabric-cdn-prod_20200430.002/assets/brand-icons/product/png/office_48x2.png',
                },
                iconSmall: {
                    uri: 'https://static2.sharepointonline.com/files/fabric-cdn-prod_20200430.002/assets/brand-icons/product/png/office_48x2.png',
                },
                shortDescription: 'Jaguar Shark Test App',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            contentUrl: 'https://jaguarshark.azurewebsites.net/',
                            entityId: 'Milestones',
                            name: 'Progress',
                            scopes: ['personal'],
                            websiteUrl: 'https://jaguarshark.azurewebsites.net',
                        },
                        {
                            contentUrl: 'https://jaguarshark.azurewebsites.net/debug',
                            entityId: 'debug',
                            name: 'Debug',
                            scopes: ['personal'],
                            websiteUrl: 'https://jaguarshark.azurewebsites.net',
                        },
                        {
                            contentUrl: 'https://jaguarshark.azurewebsites.net/launchcontent',
                            entityId: 'launchcontent',
                            name: 'LaunchContent',
                            scopes: ['personal'],
                            websiteUrl: 'https://jaguarshark.azurewebsites.net',
                        },
                    ],
                    actions: [
                        {
                            id: 'jsOpenUrl',
                            displayName: 'JaguaShark OpenUrl',
                            description: 'Test action with open intent and openUrl handler',
                            intent: 'open',
                            handlers: [
                                {
                                    type: 'openURL',
                                    supportedObjects: {
                                        file: {
                                            extensions: [
                                                'doc',
                                                'dot',
                                                'docx',
                                                'docm',
                                                'dotx',
                                                'dotm',
                                                'docb',
                                                'word',
                                            ],
                                        },
                                        folder: null,
                                    },
                                    url: 'https://scuprodprv.www.office.com/m365apps/07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff/launchcontent?flight=mosContentAction.Enabled&actionId={actionInfo.actionId}&itemId={actionInfo.actionObjects.0.itemId}&driveId={actionInfo.actionObjects.0.secondaryId.value}',
                                },
                            ],
                        },
                        {
                            id: 'jsOpenPage',
                            displayName: 'JaguaShark openPage',
                            intent: 'open',
                            description: 'Test action with open intent and openPage handler',
                            handlers: [
                                {
                                    type: 'invokeAPI',
                                    supportedObjects: {
                                        file: {
                                            extensions: [
                                                'doc',
                                                'dot',
                                                'docx',
                                                'docm',
                                                'dotx',
                                                'dotm',
                                                'docb',
                                                'word',
                                                'pdf',
                                            ],
                                        },
                                        folder: null,
                                    },
                                    url: 'https://jaguarsshark.azurewebsites.net',
                                },
                                {
                                    type: 'openPage',
                                    supportedObjects: {
                                        file: {
                                            extensions: [
                                                'doc',
                                                'dot',
                                                'docx',
                                                'docm',
                                                'dotx',
                                                'dotm',
                                                'docb',
                                                'word',
                                                'pdf',
                                            ],
                                        },
                                        folder: null,
                                    },
                                    pageInfo: {
                                        pageId: 'launchcontent',
                                        subPageId: '',
                                    },
                                },
                            ],
                        },
                        {
                            id: 'jsOpenDialog',
                            displayName: 'JaguaShark OpenDialog',
                            intent: 'custom',
                            description: 'Test action with custom intent and openDialog handler',
                            handlers: [
                                {
                                    type: 'openDialog',
                                    supportedObjects: {
                                        file: {
                                            extensions: [
                                                'doc',
                                                'dot',
                                                'docx',
                                                'docm',
                                                'dotx',
                                                'dotm',
                                                'docb',
                                                'word',
                                                'pdf',
                                            ],
                                        },
                                        folder: null,
                                    },
                                    dialogInfo: {
                                        dialogType: 'url',
                                        url: 'https://jaguarshark.azurewebsites.net/module',
                                        width: 'large',
                                        height: 'large',
                                    },
                                },
                            ],
                        },
                    ],
                },
                scope: '',
                isFullScreen: false,
                showLoadingIndicator: true,
                validDomains: [
                    '*.bing.com',
                    '*tab.azurewebsites.net',
                    'statics.teams.cdn.office.net',
                    'jaguarshark.azurewebsites.net',
                ],
                webApplicationInfo: {
                    id: '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
                    resource: 'api://jaguarshark.azurewebsites.net',
                },
                devicePermissions: [
                    'media',
                    'geolocation',
                    'notifications',
                    'midi',
                    'openExternal',
                ],
            },
            appId: '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
            canBeUnacquired: false,
            acquisitionState: 'Acquired',
        },
    },
    {
        appEnumName: PreinstalledAppNames.Park,
        definition: {
            titleId: 'P_7d396860-5e71-4ff0-bf71-8cd8bb119374',
            titleDefinition: {
                accentColor: '#d83b01',
                name: 'Park',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'https://officehome.cdn.office.net/officestartbundles/park-bundle-icon-96-blue-background.png',
                },
                iconSmall: {
                    uri: 'https://officehome.cdn.office.net/officestartbundles/park-bundle-icon-48-blue-background.png',
                },
                shortDescription: 'Prototype for the Park Application',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            contentUrl: 'https://www.office.com/park',
                            entityId: 'parkedItems',
                            name: 'Parked items',
                            scopes: ['personal'],
                            websiteUrl: 'https://www.office.com/park',
                        },
                    ],
                },
                scope: '',
                isFullScreen: false,
                showLoadingIndicator: false,
                validDomains: ['*.office.com', '*.microsoft365.com'],
            },
            appId: '7d396860-5e71-4ff0-bf71-8cd8bb119374',
            canBeUnacquired: false,
            acquisitionState: 'Acquired',
        },
    },
    {
        appEnumName: PreinstalledAppNames.Todo,
        definition: {
            titleId: 'P_7d30d5c91ee-5be2-4b79-81ed-23e6c4580427',
            titleDefinition: {
                accentColor: '#d83b01',
                name: 'To-Do',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'https://ow2.res.office365.com/todo/358299_2.43.2/icons/logo.png',
                },
                iconSmall: {
                    uri: 'https://ow2.res.office365.com/todo/362889_2.44/favicon.ico',
                },
                shortDescription: 'To Do gives you focus, from work to play.',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            contentUrl: 'https://outlook-sdf.office.com/tasks?app&branch=anvm-metaos-auth',
                            entityId: 'ToDoId',
                            name: 'To-Do',
                            scopes: ['personal'],
                            websiteUrl: 'https://outlook-sdf.office.com/tasks?app&branch=anvm-metaos-auth',
                        },
                    ],
                },
                scope: '',
                isFullScreen: false,
                showLoadingIndicator: true,
                validDomains: [
                    'nightly.to-do.officeppe.com',
                    '*.to-do.officeppe.com',
                    '*.microsoftonline.com',
                    '*.live.com',
                    'to-do.office.com',
                    '*.office.com',
                    '*.microsoft365.com',
                ],
                webApplicationInfo: {
                    id: '0d5c91ee-5be2-4b79-81ed-23e6c4580427',
                    resource: 'https://outlook-sdf.office.com',
                },
            },
            appId: '7d30d5c91ee-5be2-4b79-81ed-23e6c4580427',
            canBeUnacquired: false,
            acquisitionState: 'Acquired',
        },
    },
    {
        appEnumName: PreinstalledAppNames.Store,
        definition: {
            titleId: 'P_apps',
            titleDefinition: {
                accentColor: '#A80000',
                name: 'Apps',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'https://res-1.cdn.office.net/officehub/versionless/preinstalledapps/apps_512x512.png',
                },
                iconSmall: {
                    uri: 'https://res-1.cdn.office.net/officehub/versionless/preinstalledapps/apps_512x512.png',
                },
                shortDescription: 'Get more done with apps! Add your favorite apps and find new ways to work smarter together.',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            contentUrl: 'https://teams.microsoft.com/extensibility-apps/store/view?language={locale}&host=metaos&metaoshost=office&clienttype={hostClientType}',
                            entityId: 'apps',
                            name: 'Apps',
                            scopes: ['personal'],
                            websiteUrl: 'https://teams.microsoft.com',
                        },
                    ],
                },
                scope: '',
                isFullScreen: true,
                showLoadingIndicator: false,
                validDomains: [
                    '*.office.com',
                    '*.microsoft.com',
                    '*.microsoft365.com',
                    'teams.microsoft.com',
                ],
                webApplicationInfo: {
                    id: 'apps',
                    resource: 'https://teams.microsoft.com',
                },
                devicePermissions: [
                    'media',
                    'geolocation',
                    'notifications',
                    'midi',
                    'openExternal',
                ],
            },
            appId: 'apps',
            canBeUnacquired: false,
            acquisitionState: 'Acquired',
        },
    },
    {
        appEnumName: PreinstalledAppNames.Yammer,
        definition: {
            titleId: 'P_db5e5970-212f-477f-a3fc-2227dc7782bf',
            titleDefinition: {
                accentColor: '#093c7f',
                name: 'Communities',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'https://outlook-1.cdn.office.net/yammer/20211004001.2745867/images/YammerLogo-dccc609aadb29dbd2a112ad1242d3f59.svg',
                },
                iconSmall: {
                    uri: 'https://outlook-1.cdn.office.net/yammer/20211004001.2745867/images/YammerLogo-dccc609aadb29dbd2a112ad1242d3f59.svg',
                },
                shortDescription: 'Drive engagement in your organization through Yammer communities.',
                version: '2.2.4',
                elementDefinitions: {
                    staticTabs: [
                        {
                            contentUrl: 'https://web.yammer.com/teams/feed?client=office',
                            entityId: '1',
                            name: 'Yammer',
                            scopes: ['personal'],
                            websiteUrl: 'https://www.yammer.com',
                        },
                    ],
                },
                scope: '',
                isFullScreen: true,
                showLoadingIndicator: true,
                validDomains: [
                    'teams.yammer.com',
                    'web.yammer.com',
                    'www.yammer.com',
                ],
                webApplicationInfo: {
                    id: '00000005-0000-0ff1-ce00-000000000000',
                    resource: 'https://web.yammer.com/teams',
                },
            },
            appId: 'db5e5970-212f-477f-a3fc-2227dc7782bf',
            canBeUnacquired: false,
            acquisitionState: 'Acquired',
        },
    },
    {
        appEnumName: PreinstalledAppNames.SpfxTestApp,
        definition: {
            titleId: 'P_50e77acb-70e3-4452-bcb5-ca3e2d4a11f8',
            titleDefinition: {
                accentColor: '#004578',
                name: 'SPFX Test App',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADACAYAAABS3GwHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAO/SURBVHgB7d0xbhtHAEDRVeCbxH18iPgYZmu5kJSjREoR1coxkkMkfXIKCWoZbwwWgUTDQWxzdv57gBo2XJDzsdzRzuzZ/cPjfoGm/TcLhAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkvFjbj+vZuufn5bjmFy/PdcvVut8zGGWAjTjn4Vzfv3//6hO//pQhgA049+A9mjEAAgxtl8B/MFoEABjba4D+YKQIBDGrUwX8wSwRn9w+P+4Wh7Pf75eWr109ePzs7W/78/dflaxvteD6jvTMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkTbki7JQ3as26cmpW050BTn2X4qwrp2Y1VQCjDD4RbMc0AYw26ESwDVMEMOpgE8H4Nh/A6INMBGPb/CzQscH11x+/Lafw7XffP3ltjcDM0Jj8H4A0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANI8I2xA667Ll+92T7ZHX3dpfu5eo1O5ePtm2TpngEFdne/+iWBUsyz9FMDARo1gpnXPAhjcaBHMtuhfABswSgQz7nghgI04dQSzbvdiFmhD1gjWPz4fZwDSBECaAEgTAGkCIE0ApAmANAGQJgDSBEDatLdCrItHRnKq41kX13Dc2f3D41gj5T8aaYXUiC7Od8sPdqY+Zu8n0OR+ur1bfvR8gqMEECCC4wQQIYLnCSBEBE9NOwt0qtmPY7M9oxzPGsHKhfEH084CjfSMsJXjGZJZINoEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaZ4R9pWMdjx8sPkArt7tlutn9rx/+er1MpKRjufy3NboB5v/CbR+mVf2uv9kPq9/m+IawJf6aXxOT01zEezL/Tifz/OmmgXyJT/P53LcdLNAhwu8m9tfFpbl4u0bg/8jNv+MMPgfPCOMNgGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkv3v/tF2ja/w2mwvMhlr95TAAAAABJRU5ErkJggg==',
                },
                iconSmall: {
                    uri: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADACAYAAABS3GwHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAO/SURBVHgB7d0xbhtHAEDRVeCbxH18iPgYZmu5kJSjREoR1coxkkMkfXIKCWoZbwwWgUTDQWxzdv57gBo2XJDzsdzRzuzZ/cPjfoGm/TcLhAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkvFjbj+vZuufn5bjmFy/PdcvVut8zGGWAjTjn4Vzfv3//6hO//pQhgA049+A9mjEAAgxtl8B/MFoEABjba4D+YKQIBDGrUwX8wSwRn9w+P+4Wh7Pf75eWr109ePzs7W/78/dflaxvteD6jvTMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkTbki7JQ3as26cmpW050BTn2X4qwrp2Y1VQCjDD4RbMc0AYw26ESwDVMEMOpgE8H4Nh/A6INMBGPb/CzQscH11x+/Lafw7XffP3ltjcDM0Jj8H4A0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANI8I2xA667Ll+92T7ZHX3dpfu5eo1O5ePtm2TpngEFdne/+iWBUsyz9FMDARo1gpnXPAhjcaBHMtuhfABswSgQz7nghgI04dQSzbvdiFmhD1gjWPz4fZwDSBECaAEgTAGkCIE0ApAmANAGQJgDSBEDatLdCrItHRnKq41kX13Dc2f3D41gj5T8aaYXUiC7Od8sPdqY+Zu8n0OR+ur1bfvR8gqMEECCC4wQQIYLnCSBEBE9NOwt0qtmPY7M9oxzPGsHKhfEH084CjfSMsJXjGZJZINoEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaQIgTQCkCYA0AZAmANIEQJoASBMAaZ4R9pWMdjx8sPkArt7tlutn9rx/+er1MpKRjufy3NboB5v/CbR+mVf2uv9kPq9/m+IawJf6aXxOT01zEezL/Tifz/OmmgXyJT/P53LcdLNAhwu8m9tfFpbl4u0bg/8jNv+MMPgfPCOMNgGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkCIE0ApAmANAGQJgDSBECaAEgTAGkv3v/tF2ja/w2mwvMhlr95TAAAAABJRU5ErkJggg==',
                },
                shortDescription: 'SPFx Test App',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            contentUrl: 'https://{teamSiteDomain}/_layouts/15/TeamsLogon.aspx?SPFX=true&dest=/_layouts/15/teamshostedapp.aspx%3Fteams%26personal%26componentId=9cc0f495-db64-4d74-b06b-a3de16231fe1%26forceLocale={locale}',
                            entityId: '1805e087-3115-45da-8c46-44d622c1617d',
                            name: 'SPFX Test App',
                            scopes: ['personal'],
                            websiteUrl: 'https://products.office.com/en-us/sharepoint/collaboration',
                        },
                    ],
                },
                scope: '',
                isFullScreen: false,
                showLoadingIndicator: false,
                validDomains: [
                    '{teamsitedomain}',
                    'products.office.com',
                    '*.login.microsoftonline.com',
                    '*.sharepoint.com',
                    '*.sharepoint-df.com',
                    'spoppe-a.akamaihd.net',
                    'spoprod-a.akamaihd.net',
                    'resourceseng.blob.core.windows.net',
                    'msft.spoppe.com',
                    'msft.spoprod.com',
                ],
                devicePermissions: ['identity', 'messageTeamMembers'],
                webApplicationInfo: {
                    id: '00000003-0000-0ff1-ce00-000000000000',
                    resource: 'https://{teamSiteDomain}',
                },
            },
            appId: '50e77acb-70e3-4452-bcb5-ca3e2d4a11f8',
            acquisitionState: 'Acquired',
            canBeUnacquired: false,
        },
    },
    {
        appEnumName: PreinstalledAppNames.ImmersiveBizchat,
        definition: {
            titleId: 'd870f6cd-4aa5-4d42-9626-ab690c041429',
            titleDefinition: {
                accentColor: '#0033cc',
                name: 'M365 Chat',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'https://res.cdn.office.net/officehub/officestartresources/m365chat-icon-color.svg',
                },
                iconSmall: {
                    uri: 'https://res.cdn.office.net/officehub/officestartresources/m365chat-icon-color.svg',
                },
                shortDescription: 'Microsoft 365 Chat',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            entityId: 'entity1-d870f6cd-4aa5-4d42-9626-ab690c041429',
                            name: 'M365 Chat',
                            contentUrl: generateUrlWithCarryOverParams('https://outlook.office.com/hosted/semanticoverview?hostApp=hub&isanonymous=true&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage', [
                                'branch',
                                'M365ChatBranch',
                                'M365ChatLocal',
                                'M365ChatVersion',
                                'M365ChatMode',
                                'gulp',
                                'cspoff',
                            ], ['features']),
                            scopes: ['personal'],
                            websiteUrl: 'https://outlook.office.com/hosted/semanticoverview?hostApp=hub&isanonymous=true&features=immersive-bizchat-feature,immersive-bizchat-standalone,immersive-disable-bizchat-feed-homepage',
                        },
                    ],
                },
                scope: '',
                isFullScreen: true,
                showLoadingIndicator: false,
                validDomains: [
                    '*.office.com',
                    '*.microsoft.com',
                    '*.microsoft365.com',
                ],
                devicePermissions: [],
                webApplicationInfo: {
                    id: 'd870f6cd-4aa5-4d42-9626-ab690c041429',
                    resource: 'https://outlook.office.com/',
                },
            },
            appId: 'd870f6cd-4aa5-4d42-9626-ab690c041429',
            acquisitionState: 'Acquired',
            canBeUnacquired: false,
        },
    },
    {
        appEnumName: PreinstalledAppNames.OneDrive,
        definition: {
            titleId: 'P_377c982d-9686-450e-9a7c-22aeaf1bc162',
            titleDefinition: {
                accentColor: '#40497E',
                name: 'OneDrive',
                developerName: 'Microsoft',
                iconLarge: {
                    uri: 'https://res-1.cdn.office.net/shellux/onedrive_24x.48ff325b96939ffeb92ab7ba4dc237d1.svg',
                },
                iconSmall: {
                    uri: 'https://res-1.cdn.office.net/shellux/onedrive_24x.48ff325b96939ffeb92ab7ba4dc237d1.svg',
                },
                shortDescription: 'Official OneDrive app for Microsoft 365',
                version: '1.0.0',
                elementDefinitions: {
                    staticTabs: [
                        {
                            entityId: '7211f19f-262a-42eb-a02e-289956491741',
                            name: 'OneDrive',
                            contentUrl: 'https://{mySiteDomain}{mySitePath}/_layouts/15/filebrowser.aspx?app=MetaOS&fileBrowser={"sdk":"8.0","entry":{"oneDrive":{}},"metaOS":{"host":"{hostName}"},"theme":"{theme}","telemetry":{"ring":"{ringId}","correlationId":"{appSessionId}"}}&scenario=OneDrive&auth=none&locale={locale}',
                            scopes: ['personal'],
                            websiteUrl: 'https://go.microsoft.com/fwlink/?linkid=2225080',
                        },
                    ],
                },
                scope: '',
                isFullScreen: true,
                showLoadingIndicator: true,
                validDomains: [
                    '*.office.com',
                    '*.microsoft.com',
                    '*.microsoft365.com ',
                ],
                devicePermissions: [],
                webApplicationInfo: {
                    id: '08e18876-6177-487e-b8b5-cf950c1e598c',
                    resource: 'https://{mySiteDomain}',
                },
            },
            appId: '377c982d-9686-450e-9a7c-22aeaf1bc162',
            acquisitionState: 'Acquired',
            canBeUnacquired: false,
        },
    },
];
//# sourceMappingURL=preinstalledApps.js.map